import { Input } from "expano-components";
import useCreate from "hooks/useCreate";
import { Dashboard } from "components";

const AllegroAds = ({
  id,
  allegro_ads_client_id,
  allegro_ads_client_type,
  allegro_ads_client_status,
  allegro_ads_client_name,
  refetch,
}) => {
  const { is_creating, create: sync } = useCreate({
    path: `/channels/${id}/sync_with_allegro`,
    success_message: "Synchronizacja przebiegła pomyślnie",
    onSuccess: refetch,
  });

  return (
    <Dashboard
      header={{
        icon: "info",
        title: "Allegro Ads",
        aside: (
          <button
            className="btn btn-sm btn-blue"
            disabled={is_creating}
            onClick={() => sync({})}
          >
            <span>
              {is_creating ? "Proszę czekać" : "Synchronizuj z Allegro"}
            </span>
          </button>
        ),
      }}
    >
      <div className="dashboard__form">
        <div className="row m-b-20">
          <div className="box-6">
            <Input
              meta={{}}
              input={{
                value: allegro_ads_client_id,
                readOnly: true,
                name: "ID",
              }}
              label="ID klienta"
              readOnly
              type="text"
            />
          </div>
          <div className="box-6">
            <Input
              meta={{}}
              input={{
                value: allegro_ads_client_name,
                readOnly: true,
                name: "type",
              }}
              label="Nazwa klienta"
              readOnly
              type="text"
            />
          </div>
        </div>
        <div className="row">
          <div className="box-6">
            <Input
              meta={{}}
              input={{
                value: allegro_ads_client_status,
                readOnly: true,
                name: "status",
              }}
              label="Status klienta"
              readOnly
              type="text"
            />
          </div>

          <div className="box-6">
            <Input
              meta={{}}
              input={{
                value: allegro_ads_client_type,
                readOnly: true,
                name: "type",
              }}
              label="Typ klienta"
              readOnly
              type="text"
            />
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default AllegroAds;
